import { useState } from "react";
import SectionHeader from "../SectionHeader";
import { BsHeart, BsZoomIn } from "react-icons/bs";
import { CiShoppingCart } from "react-icons/ci";

const tabs = [
  {
    id: 1,
    text: "New Arrival",
  },
  {
    id: 2,
    text: "Best Seller",
  },
  {
    id: 3,
    text: "Featured",
  },
  {
    id: 4,
    text: "Special Offer",
  },
];

export default function LatestProducts() {
  const [currentTab, setCurrentTab] = useState(1);

  return (
    <>
      <SectionHeader>Latest Products</SectionHeader>
      {/* changing tabs */}
      <div className="flex justify-center">
        {tabs.map((value) => (
          <button
            className={`${
              currentTab === value.id ? "text-pink underline" : null
            } hover:text-pink hover:underline mx-4 font-fontTwo`}
            onClick={() => setCurrentTab(value.id)}
            key={value.id}
          >
            {value.text}
          </button>
        ))}
      </div>
      {/* grid view */}
      <div className="w-full mt-8">
        <div
          className={`${
            currentTab === 1 ? "grid" : "hidden"
          } grid-cols-3 max-w-5xl mx-auto gap-4 gap-y-24 `}
        >
          <Card img={require("../../assets/home/latest-products/img01.png")} />
          <Card img={require("../../assets/home/latest-products/img02.png")} />
          <Card img={require("../../assets/home/latest-products/img03.png")} />
          <Card img={require("../../assets/home/latest-products/img04.png")} />
          <Card img={require("../../assets/home/latest-products/img05.png")} />
          <Card img={require("../../assets/home/latest-products/img06.png")} />
        </div>
        <div
          className={`${
            currentTab === 2 ? "grid" : "hidden"
          } grid-cols-3 max-w-5xl mx-auto gap-4 gap-y-24 `}
        >
          <Card img={require("../../assets/home/latest-products/img02.png")} />
          <Card img={require("../../assets/home/latest-products/img01.png")} />
          <Card img={require("../../assets/home/latest-products/img03.png")} />
          <Card img={require("../../assets/home/latest-products/img05.png")} />
          <Card img={require("../../assets/home/latest-products/img06.png")} />
          <Card img={require("../../assets/home/latest-products/img04.png")} />
        </div>
        <div
          className={`${
            currentTab === 3 ? "grid" : "hidden"
          } grid-cols-3 max-w-5xl mx-auto gap-4 gap-y-24 `}
        >
          <Card img={require("../../assets/home/latest-products/img05.png")} />
          <Card img={require("../../assets/home/latest-products/img02.png")} />
          <Card img={require("../../assets/home/latest-products/img03.png")} />
          <Card img={require("../../assets/home/latest-products/img01.png")} />
          <Card img={require("../../assets/home/latest-products/img04.png")} />
          <Card img={require("../../assets/home/latest-products/img06.png")} />
        </div>
        <div
          className={`${
            currentTab === 4 ? "grid" : "hidden"
          } grid-cols-3 max-w-5xl mx-auto gap-4 gap-y-24 `}
        >
          <Card img={require("../../assets/home/latest-products/img05.png")} />
          <Card img={require("../../assets/home/latest-products/img01.png")} />
          <Card img={require("../../assets/home/latest-products/img02.png")} />
          <Card img={require("../../assets/home/latest-products/img04.png")} />
          <Card img={require("../../assets/home/latest-products/img06.png")} />
          <Card img={require("../../assets/home/latest-products/img03.png")} />
        </div>
      </div>
    </>
  );
}

function Card({ img }) {
  return (
    <div className=" w-80 group">
      {/* image container */}
      <div className="bg-[#F7F7F7] flex justify-center items-center h-64 relative ">
        {/* on hover elements */}
        <div className=" absolute top-0 left-0 bottom-0 right-0 hidden group-hover:flex flex-col justify-end items-start pl-2 pb-2">
          <div className=" transition-all text-text hover:bg-bg_shade p-2 rounded-full ">
            <CiShoppingCart className="-translate-x-[3px]" size={20} />
          </div>
          <div className="  transition-all text-text hover:bg-bg_shade p-2 rounded-full">
            <BsHeart size={15} />
          </div>
          <div className="  transition-all text-text hover:bg-bg_shade p-2 rounded-full">
            <BsZoomIn size={15} />
          </div>
        </div>
        {/* image */}
        <img src={img} alt="" />
      </div>
      {/* text container */}
      <div className="flex justify-between px-1 mt-2 text-text font-fontOne">
        {/* left side */}
        <p className=" border-b-2 border-gray-200">Comfort Handy Craft</p>
        {/* right side (prices) */}
        <div className="flex font-fontOne">
          <div>$42.00</div>
          <div className=" text-pink line-through ml-3">$65.00</div>
        </div>
      </div>
    </div>
  );
}
